// const EmployeeStateDetailsView = () => import('@/views/other/EmployeeStateView.vue')

export default [
  // {
  //     path: '/other/employee-state/:id',
  //     name: 'EmployeeState',
  //     component: EmployeeStateDetailsView,
  //     props: (route: _RouteLocationBase) => {
  //         return { id: parseInt(<string>route.params.id) }
  //     }
  // }
]
